module.exports = __webpack_public_path__ + "img/pup18.06e25592.jpg";